export default "__VITE_ASSET__B5qY8gzP__"